// Managed image slots. Portal cover is optional and falls back to the calculator hero photo on the server.
export const IMAGE_SLOT_ORDER = ['logoURL', 'calculatorHeroURL', 'portalCoverURL', 'pdfHeaderURL', 'firstImage', 'secondImage', 'thirdImage', 'forthImage', 'fifthImage'];

export const IMAGE_SLOT_DESCRIPTIONS = {
    logoURL: 'Company logo displayed in documents and communications',
    calculatorHeroURL: 'Optional completed-installation photo shown in the calculator and results',
    portalCoverURL: 'Optional photo for the customer portal header. Falls back to the calculator hero photo.',
    pdfHeaderURL: 'Header image used in PDF exports',
    firstImage: 'Full page background image for the Cover Page',
    secondImage: 'Full page background image for the Introduction Page',
    thirdImage: 'Full page background image for the Notable Exclusions page',
    forthImage: 'Full page background image for Closing Page 1',
    fifthImage: 'Full page background image for Closing Page 2',
};

// Ensures optional slots always appear as cards even when the stored document predates them.
export const withManagedImageSlots = (images) => ({
    ...(images || {}),
    calculatorHeroURL: images?.calculatorHeroURL || null,
    portalCoverURL: images?.portalCoverURL || null,
});

export const sortImageSlots = (entries) => [...entries].sort(([a], [b]) => {
    const ai = IMAGE_SLOT_ORDER.indexOf(a);
    const bi = IMAGE_SLOT_ORDER.indexOf(b);
    if (ai === -1 && bi === -1) return a.localeCompare(b);
    if (ai === -1) return 1;
    if (bi === -1) return -1;
    return ai - bi;
});
